module.exports = __webpack_public_path__ + "img/152.8496a10e.jpg";